// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"a158c1fd","215":"db55092f","359":"f74e2131","572":"7f0ff811","810":"e26c4d05","948":"fc25f2ee"}[chunkId] + ".chunk.js";
};